export class PrescriptionDeliveryTargetConst {
	public static readonly HOME = 1;
	public static readonly STORE = 2;
}
